// extracted by mini-css-extract-plugin
module.exports = {"indicator":"N_R2LYX8","shadedArea":"AAS0tgcS"};